export const FORM_CLASS_LABEL = 'formElements:class_label';
export const FORM_GROUP_LABEL = 'formElements:group_label';
export const FORM_LESSON_LABEL = 'formElements:lesson_label';
export const FORM_ROOM_LABEL = 'formElements:room_label';
export const FORM_TYPE_LABEL = 'formElements:type_label';
export const TYPE_LABEL = 'formElements:type_element';
export const FORM_CLASS_FROM_LABEL = 'formElements:class_from_label';
export const FORM_CLASS_TO_LABEL = 'formElements:class_to_label';
export const FORM_SEMESTER_LABEL = 'formElements:semester_label';
export const FORM_STUDENT_ADD_LABEL = 'formElements:student_add_label';
export const FORM_SHOW_STUDENTS = 'formElements:show_students';
export const FORM_SHOW_GROUPS = 'formElements:show_groups';
export const FORM_STUDENT_LABEL = 'formElements:student_a_label';
export const FORM_SUBJECT_LABEL = 'formElements:subject_label';
export const FORM_TEACHER_A_LABEL = 'formElements:teacher_a_label';
export const FORM_TEACHER_LABEL = 'formElements:teacher_label';
export const FORM_COPY_LESSON = 'formElements:copy_label';
export const FORM_CURRICULUM_LABEL = "formElements:curriculum_label";
export const FORM_SEMESTER_FREE_ROOMS = 'formElements:semester_free_rooms';
export const FORM_WEEK_FREE_ROOMS = 'formElements:week_free_rooms';
export const FORM_DAY_FREE_ROOMS = 'formElements:day_free_rooms';
export const FORM_CLASS_FREE_ROOMS = 'formElements:class_free_rooms';
export const FORM_SUBMIT_BUTTON_LABEL = 'formElements:submit_button_label';
export const FORM_CLEAR_BUTTON_LABEL = 'formElements:clear_button_label';
export const FORM_GROUPED_LABEL = 'formElements:grouped_label';
export const FORM_SEMESTER_COPY_HINT = 'formElements:semester_copy_hint';
export const FORM_SEMESTER_COPY_RED_HINT = 'formElements:semester_copy_red_hint';
export const FORM_USER_LABEL = 'formElements:user_label';
export const FORM_STUDENT_FILE_LABEL = 'formElements:student_file_label';
export const FORM_STUDENTS_FILE_LABEL = 'formElements:students_file_label';
export const FORM_TEMPORARY_SCHEDULE_LABEL = 'formElements:temporary_schedule_label';
export const FORM_CHOSEN_SEMESTER_LABEL = 'formElements:chosen_semester_label';
export const FORM_SCHEDULE_LABEL = 'formElements:schedule_label';
export const FORM_DEPARTMENT_LABEL = 'formElements:department_label';
export const FORM_DAY_LABEL = 'formElements:day_label';
export const FORM_CHOOSE_BUTTON_TITLE = 'formElements:choose_button_title';
export const FORM_CANCEL_BUTTON_TITLE = 'formElements:cancel_button_title';
export const CANCEL_BUTTON_TITLE = 'cancel_button_title';
export const EDIT_TITLE = 'edit_title';
export const SEND_LETTER_LABEL = 'send_letter_title';
export const SELECT_ALL = 'select_all';
export const SELECT_STUDENT = 'select_student';
export const STUDENT_ACTIONS = 'student_actions';
export const ROWS_PER_PAGE = 'rows_per_page';
export const ALL_PAGE = 'all_page';
export const CREATE_TITLE = 'create_title';
export const DELETE_TITLE = 'delete_title';
export const SHOW_TEACHER_TITLE = 'show_teacher_title';
export const SET_DEFAULT_TITLE = 'set_default_title';
export const EDIT_TEMPORARY_SCHEDULE_FORM = 'edit_temporary_schedule_form';
export const CREATE_TEMPORARY_SCHEDULE_FORM = 'create_temporary_schedule_form';
export const EDIT_VACATION_FORM = 'edit_vacation_form';
export const CREATE_VACATION_FORM = 'create_vacation_form';
export const TEACHER_LABEL = 'teacher_label';
export const TEACHERS_LABEL = 'teachers_label';
export const LINK_TO_MEETING_LABEL = 'link_to_meeting_label';
export const GROUP_LABEL = 'group_label';
export const CLASS_LABEL = 'class_label';
export const ROOM_LABEL = 'room_label';
export const STUDENT_FULL_NAME = 'full_name';
export const STUDENT_LABEL = 'student_label';
export const SUBJECT_LABEL = 'subject_label';
export const DEPARTMENT_TEACHER_LABEL = 'department_teachers_label';
export const DEPARTMENT_TEACHERS = 'department_teachers';
export const GROUP_STUDENTS = 'group_students';
export const HOURS_LABEL = 'hours_label';
export const HOURS_LABEL_SHORT = 'hours_label_short';
export const LESSON_LABEL = 'lesson_label';
export const TEACHER_A_LABEL = 'teacher_a_label';
export const STUDENT_A_LABEL = 'student_a_label';
export const GROUP_Y_LABEL = 'group_y_label';
export const CLASS_Y_LABEL = 'class_y_label';
export const ROOM_Y_LABEL = 'room_y_label';
export const SUBJECT_Y_LABEL = 'subject_y_label';
export const DEPARTMENT_LABEL = 'department_y_label';
export const EMAIL_LABEL = 'formElements:email_label';
export const PASSWORD_LABEL = 'formElements:password_label';
export const RETYPE_PASSWORD_LABEL = 'formElements:retype_password_label';
export const NEW_PASSWORD_LABEL = 'formElements:new_password_label';
export const SEMESTERY_LABEL = 'semestry_label';
export const TEACHER_FIRST_NAME = 'teacher_first_name';
export const TEACHER_SURNAME = 'teacher_surname';
export const PATRONYMIC_PLACEHOLDER = 'patronymic_placeholder';
export const NAME_PLACEHOLDER = 'name_placeholder';
export const SURNAME_PLACEHOLDER = 'surname_placeholder';
export const NAME_LABEL = 'name';
export const TEACHER_PATRONYMIC = 'teacher_patronymic';
export const TEACHER_POSITION = 'teacher_position';
export const EMAIL_FIELD = 'email_field';
export const FOR_SITE_LABEL = 'for_site_label';
export const NOT_SELECTED_LABEL = 'not_selected_label';
export const FOR_TEACHER = 'for_teacher';
export const SAVE_BUTTON_LABEL = 'save_button_label';
export const COPY_GROUPS_LABEL = 'copy_groups_label';
export const GROUPS_LABEL = 'groups_label';
export const COPY_FOR_BUTTON_LABEL = 'copy_for_button_label';
export const CLEAR_BUTTON_LABEL = 'clear_button_label';
export const CLASS_FROM_LABEL = 'class_from_label';
export const CLASS_TO_LABEL = 'class_to_label';
export const TYPE_TO_SEARCH = 'type_to_search';
export const THERE_IS_NO = 'there_is_no';
export const FIND_FREE_ROOM = 'find_free_room';
export const NUMBER_LABEL = 'number_label';
export const ADD_TYPE_LABEL = 'add_type_label';
export const STUDENTS_LABEL = 'students_label';
export const FORM_SEMESTER_ELEMENT = 'formElements:semester_element';
export const FORM_REFERENCE_ELEMENT = 'formElements:reference_element';
export const MAX_COUNT_CLASSES_REACHED = 'max_count_classes_reached';
export const CHANGE_PASSWORD_FROM_TITLE = 'change_password_form_title';
export const SEMESTER_COPY_LABEL = 'semester_copy_label';
export const CLOSE_LABEL = 'close_label';
export const COPY_LABEL = 'copy_label';
export const SHOW_ARCHIVED = 'show_archived';
export const SHOW_REGULAR = 'show_regular';
export const NO_EXIST_TEACHER_AT_DEPARTMENT = 'no_exist_teachers_at_department';
export const NO_EXIST_STUDENTS_AT_GROUP = 'no_exist_students_in_group';
export const NEW_TYPE_LABEL = 'new_type_label';
export const DELETE_TITLE_LABEL = 'delete_title';
export const CREATE_ACCOUNT_LABEL = 'formElements:create_account_label';
export const FORGOT_PASSWORD_LABEL = 'formElements:forgot_password_label';
export const DONT_HAVE_ACCOUNT_LABEL = 'formElements:dont_have_an_account';
export const LOGIN_VIA_GOOGLE_LABEL = 'formElements:login_via_google';
export const RESET_PASSWORD_HELPER_TEXT = 'formElements:reset_password_helper_text';
export const FORM_CHOOSE_GROUP_LABEL = 'choose_group_title';
export const FORM_GROUP_LABEL_AFTER = 'form_group_label_after';
export const STUDENTS_UPPERCASE = 'formElements:students_uppercase';
export const FORM_ROOM_LABEL_AFTER = 'formElements:room_label_after';
export const FORM_DEPARTMENT_TEACHERS_LABEL = 'formElements:department_teachers_label';
export const GROUP_VIEW_GRID = 'grid_view';
export const GROUP_VIEW_COURSES = 'courses_view';
export const GROUP_VIEW_DEPARTMENTS = "departments_view";
export const VIEW_AZ = 'az_view';
export const UNGROUP_LESSON= "formElements:ungroup_lesson";
export const UNGROUP_CONFIRM_TITLE = "formElements:ungroup_confirm_title";
export const UNGROUP_CONFIRM_WARNING = "formElements:ungroup_confirm_warning";
export const FROM_CURRICULUM_CREATE_ROW = "formElements:from_curriculum_create_row";
